module.exports = __webpack_public_path__ + "static/day03-7a1e4c34a087253f4fabc7414d1ad4c8.png";